import { render, staticRenderFns } from "./ShippingView.vue?vue&type=template&id=2feae7d0"
import script from "./ShippingView.vue?vue&type=script&lang=js"
export * from "./ShippingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports